<button mat-stroked-button color="primary" class="custom-mat-button custom-mat-stroked-button custom-mat-button-primary rounded">{{text}}</button>
